import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { LoggingService } from '../shared/services/logging';

@Injectable({
    providedIn: 'root'
})
export class ImportService {
    private uri = `${environment.apiLocation}/ExternalEmployee`;
    constructor(private http: HttpClient, private log: LoggingService) {}

    public LoadData(includeInactive: boolean): Promise<any> {
        return this.http
            .get(
                `${this.uri}/SyncExternalEmployees?includeInactive=${includeInactive}`
            )
            .toPromise()
            .then(() =>
                this.log.verbose({
                    type: 'ImportService:LoadData:SyncExternalEmployees'
                })
            )
            .catch(reason => {
                this.log.error({
                    type: 'ImportService:SyncExternalEmployees',
                    reason
                });
                throw reason;
            });
    }
}
